import e from "@dialpad/dialtone-tokens/layered/themes/tokens-103-colors.css?inline";
//#region themes/103.js
var t = { brand: {
	css: e,
	name: "103"
} };
//#endregion
export { t as default };
